import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { DynamicsChart } from '/@/app/components/DynamicsChart';
//
import { HelpingDrawerLayout } from '/@/app/views/common/HelpingDrawerLayout';
//
import { TesterViewMenu } from '/@/app/views/TesterView/TesterViewMenu';


const NextExampleHeader = ({ children }) => {
    return (
        <Typography variant="h6" sx={{mt: 3}}>
            {children}
        </Typography>
    );
}


export const DynamicsCasesTypical = () => {
    return (
        <HelpingDrawerLayout
            drawerContent={TesterViewMenu}
            buttonText="Разделы"
            // customized smaller sidebar
            sidebarWidth={{xs: "0", lg: "300px"}}
            drawerWidth={{xs: "100vw", sm: "300px"}}

        >
            <Container maxWidth="sm">
                <Box sx={{
                    pr: {xs: 2, sm: 0},
                    pb: 10,  // keep bottom space for floating bottom panels
                }}>
                    <Typography variant="h2" gutterBottom>Динамика: Главные тест-кейсы</Typography>
                    <Typography variant="body1" gutterBottom>
                        Синтетические кейсы типичных пользователей.
                    </Typography>
                    <DynamicsCasesOverview />
                </Box>
            </Container>
        </HelpingDrawerLayout>
    );
}

const DynamicsCasesOverview = () => {
    return (
        <>
            <Typography variant="h4" gutterBottom>Типичный Новый Пользователь</Typography>
            <CASES.NewUser.FewRecentTests />
            <CASES.NewUser.SparseTests />
            <CASES.NewUser.FrequentTests />

            <Typography variant="h4" gutterBottom>Типичный Биохакер</Typography>
            <CASES.Biohacker.EveryDaySevenTimes />
            <CASES.Biohacker.EveryDaySevenTimesAndAMonthLater />
            <CASES.Biohacker.EveryWeekTenWeeks />
            <CASES.Biohacker.EveryMonthTenMonths />
            <CASES.Biohacker.EveryWeekTenWeeksAndSameFiveYearsAgo />
        </>
    );
}


const CASES = {
        NewUser: {
            FewRecentTests: () => {
                return (
                    <>
                        <NextExampleHeader>Новый Юзер: несколько тестов недавно</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2020-05-10T00:00:00Z",
                                "value": 18,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-05-15T00:00:00Z",
                                "value": 25,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-05-20T00:00:00Z",
                                "value": 18,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-05-21T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]}/>
                    </>
                )
            },
            SparseTests: () => {
                return (
                    <>
                        <NextExampleHeader>Новый Юзер: несколько редких тестов</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2016-01-10T00:00:00Z",
                                "value": 4.8,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-06-10T00:00:00Z",
                                "value": 6,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2021-10-10T00:00:00Z",
                                "value": 14,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
            FrequentTests: () => {
                return (
                    <>
                        <NextExampleHeader>Новый Юзер: частые тесты (раз в неделю-две)</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-10T00:00:00Z",
                                "value": 11,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-17T00:00:00Z",
                                "value": 3,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-21T00:00:00Z",
                                "value": 6,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-01T00:00:00Z",
                                "value": 8,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-07T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-14T00:00:00Z",
                                "value": 8,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-27T00:00:00Z",
                                "value": 25,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-03-05T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-03-10T00:00:00Z",
                                "value": 26,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-03-21T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-04-01T00:00:00Z",
                                "value": 18,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
        },
        Biohacker: {
            EveryDaySevenTimes: () => {
                return (
                    <>
                        <NextExampleHeader>Биохакер: каждый день, 7 дней, 1 пропуск</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-11T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-12T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-13T00:00:00Z",
                                "value": 80,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-14T00:00:00Z",
                                "value": 17,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-15T00:00:00Z",
                                "value": 25,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-17T00:00:00Z",
                                "value": 2,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-18T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
            EveryDaySevenTimesAndAMonthLater: () => {
                return (
                    <>
                        <NextExampleHeader>Биохакер: каждый день 7 дней, повтор через месяц</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-11T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-12T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-13T00:00:00Z",
                                "value": 60,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-14T00:00:00Z",
                                "value": 17,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-15T00:00:00Z",
                                "value": 25,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-17T00:00:00Z",
                                "value": 2,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-05-18T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },

                            {
                                "panel_id": 1,
                                "made_at": "2018-06-11T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-12T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-13T00:00:00Z",
                                "value": 50,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-14T00:00:00Z",
                                "value": 17,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-15T00:00:00Z",
                                "value": 25,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-17T00:00:00Z",
                                "value": 2,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2018-06-18T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
            EveryWeekTenWeeks: () => {
                return (
                    <>
                        <NextExampleHeader>Биохакер: каждую неделю 10 недель</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-01T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-07T00:00:00Z",
                                "value": 22,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-14T00:00:00Z",
                                "value": 14,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-21T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-28T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-04T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-11T00:00:00Z",
                                "value": 5,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-18T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-25T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-03-03T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
            EveryMonthTenMonths: () => {
                return (
                    <>
                        <NextExampleHeader>Биохакер: каждый месяц 10 месяцев</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2020-05-14T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-06-14T00:00:00Z",
                                "value": 26,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-07-14T00:00:00Z",
                                "value": 21,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-08-14T00:00:00Z",
                                "value": 17,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-09-14T00:00:00Z",
                                "value": 15,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-10-14T00:00:00Z",
                                "value": 31,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-11-14T00:00:00Z",
                                "value": 3,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-12-14T00:00:00Z",
                                "value": 55,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2021-01-14T00:00:00Z",
                                "value": 15,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2021-02-14T00:00:00Z",
                                "value": 20,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
            EveryWeekTenWeeksAndSameFiveYearsAgo: () => {
                return (
                    <>
                        <NextExampleHeader>Биохакер: каждую неделю 10 недель + то же самое 5 лет назад</NextExampleHeader>
                        <DynamicsChart data={[
                            {
                                "panel_id": 1,
                                "made_at": "2015-01-01T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-01-07T00:00:00Z",
                                "value": 22,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-01-14T00:00:00Z",
                                "value": 14,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-01-21T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-01-28T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-02-04T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-02-11T00:00:00Z",
                                "value": 5,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-02-18T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-02-25T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2015-03-03T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },


                            {
                                "panel_id": 1,
                                "made_at": "2020-01-01T00:00:00Z",
                                "value": 12,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-07T00:00:00Z",
                                "value": 22,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-14T00:00:00Z",
                                "value": 14,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-21T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-01-28T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-04T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-11T00:00:00Z",
                                "value": 5,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-18T00:00:00Z",
                                "value": 1,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-02-25T00:00:00Z",
                                "value": 10,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                            {
                                "panel_id": 1,
                                "made_at": "2020-03-03T00:00:00Z",
                                "value": 4,
                                "warning_bottom_edge": 5,
                                "warning_top_edge": 20
                            },
                        ]} />
                    </>
                )
            },
        },
}
